import React from 'react';
import { withYMaps } from 'react-yandex-maps';
import {
  object, func, shape,
} from 'prop-types';
import { renderToString } from 'react-dom/server';
import classNames from 'classnames/bind';

import s from './index.module.css';
import { ReactComponent as FullScreenIcon } from '../assets/full-screen.svg';

const cx = classNames.bind(s);

const fullScreenButton =  
  <button type="button" className={cx(s.fullScreenButton)}>
    <FullScreenIcon/>
  </button>

const TemplateProvider = ({ ymaps, children }) => {
  const zoomLayout = ymaps.templateLayoutFactory.createClass(
    renderToString(fullScreenButton), {}
  );

  return children({ template: zoomLayout });
}

TemplateProvider.propTypes = {
  children: func,
  ymaps: shape({ templateLayoutFactory: object }),
};

TemplateProvider.defaultProps = {
  children: null,
  ymaps: null
};

const FullScreenTemplateProvider = withYMaps(TemplateProvider, true, [
  'templateLayoutFactory',
]);

export default FullScreenTemplateProvider;